// CHANGE: feature flags and role for admin UI (from GET /api/admin/config)
import { useEffect, useState } from 'react';
import { getAdminConfig, type AdminConfig } from '../api/admin.api';
import { getTelegramInitData } from '../utils/initData';

export function useAdminConfig() {
  const [config, setConfig] = useState<AdminConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const initData = getTelegramInitData();
    if (!initData) {
      setConfig(null);
      setError('Админ-панель доступна только из Telegram Mini App (нет initData).');
      setLoading(false);
      return () => {
        cancelled = true;
      };
    }
    getAdminConfig()
      .then((nextConfig) => {
        if (cancelled) return;
        setConfig(nextConfig);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setConfig(null);
        setError(err instanceof Error ? err.message : 'Не удалось загрузить конфигурацию админ-панели.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  const reload = () => setReloadKey((v) => v + 1);

  return { config, loading, error, reload, features: config?.features ?? null };
}
